import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { activateUserAPI } from './api';

export function useActivateUser() {
  const { openModal } = useModal();
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError } = useMutation(
    (user) => activateUserAPI(user.userId),
    {
      onError: (error, userId) => openModal({
        modalType: 'PopupModal',
        modalProps: {
          title: 'Unable to activate user',
          description: 'An error occurred while activating the user.',
          onRetry: () => mutate(userId),
        },
      }),
      onSuccess: () => {
        queryClient.invalidateQueries('users');
      },
    },
  );

  return {
    activateUser: mutate,
    isLoading,
    isError,
  };
}
